export enum DateAdjustmentIndicatorEnum {
  'Yes' = 'Y',
  'No' = 'N'
}

export namespace DateAdjustmentIndicatorEnum {
  export function values() {
    return Object.keys(DateAdjustmentIndicatorEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
